import userService from 'ApiService/Student/userService';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const ProfilePic = () => {
  const [profileImage, setProfileImage] = useState(null); // Stores profile image data
  const [selectedImage, setSelectedImage] = useState(false); // Used for full-view modal

  const BASE_URL = `${process.env.REACT_APP_API_BASE_URL.replace(
    '/api/v1',
    ''
  )}`;

  const fetchStudentProfileImage = async () => {
    try {
      const response = await userService.getProfilePic();

      if (response.data.success && response.data.data) {
        const { profilePicture, profilePictureFileName } = response.data.data;

        const fileExtension = profilePictureFileName
          .split('.')
          .pop()
          .toLowerCase();
        if (['png', 'jpeg', 'jpg', 'gif', 'webp'].includes(fileExtension)) {
          setProfileImage({
            filepath: profilePicture,
            filename: profilePictureFileName,
          });
        } else {
          toast.error('Invalid image format');
        }
      } else {
        toast.error(response.data.message || 'No profile image found');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch profile image.'
      );
    }
  };

  useEffect(() => {
    fetchStudentProfileImage();
  }, []);

  const handleImageClick = () => {
    setSelectedImage(true);
  };

  const closeImageView = () => {
    setSelectedImage(false);
  };

  const imagePath = profileImage
    ? `${BASE_URL}/${profileImage.filepath.replace(/\\/g, '/')}`
    : '';

  return (
    <div>
      <div
        className="h-10 w-10 cursor-pointer overflow-hidden rounded-full "
        onClick={handleImageClick}
      >
        <img
          src={imagePath}
          alt={profileImage?.filename || 'Profile'}
          className="h-full w-full object-cover"
        />
      </div>

      {/* Full Image View Modal */}
      {/* {selectedImage && profileImage && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4"
          onClick={closeImageView}
        >
          <div className="max-w-full max-h-full">
            <img
              src={`${BASE_URL}/${profileImage.filepath.replace(/\\/g, '/')}`}
              alt={profileImage.filename}
              className="max-w-full max-h-[90vh] object-contain"
            />
            <p className="text-white text-center mt-4">{profileImage.filename}</p>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ProfilePic;
